var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'AddNewPost' }}},[_c('div',{staticClass:"add-post-btn"},[_c('q-btn',{attrs:{"round":"","color":"lale-primary","icon":"fal fa-plus","size":"20px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }